/** HU 8338 — una alianza = varios NeoBanner Estrategico, agrupados por código en nombre_archivo. */

export const ALIANZA_SLOT = {
  CARD: 'CARD',
  CB1: 'CB1',
  CB2: 'CB2',
  CB3: 'CB3',
  CB4: 'CB4',
  LANDING: 'LANDING',
  LCTA: 'LCTA',
  LB1: 'LB1',
  LB2: 'LB2',
  LB3: 'LB3',
} as const;

export type AlianzaSlot = (typeof ALIANZA_SLOT)[keyof typeof ALIANZA_SLOT];

const SLOT_RE = /^(.*)_(CARD|CB[1-4]|LANDING|LCTA|LB[1-3])$/i;

export const ALIANZA_ORDEN_SLOT: Record<AlianzaSlot, number> = {
  CARD: 0,
  CB1: 1,
  CB2: 2,
  CB3: 3,
  CB4: 4,
  LANDING: 5,
  LCTA: 6,
  LB1: 7,
  LB2: 8,
  LB3: 9,
};

export const ALIANZA_GRUPO_ORDEN_SPAN = 20;

export interface AlianzaFila {
  idBanner?: number | null;
  nombreArchivo?: string | null;
  titulo?: string | null;
  contenido?: string | null;
  nombreBoton?: string | null;
  urlArchivo?: string | null;
  urlForward?: string | null;
  orden?: number | null;
  estado?: string | null;
}

export interface AlianzaGrupo {
  codigo: string;
  filas: AlianzaFila[];
  porSlot: Partial<Record<AlianzaSlot, AlianzaFila>>;
}

export function normalizarCodigoAlianza(raw: string | null | undefined): string {
  return String(raw ?? '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 20);
}

export function nombreArchivoAlianza(codigo: string, slot: string): string {
  return `${normalizarCodigoAlianza(codigo)}_${slot}`;
}

export function parseAlianzaNombreArchivo(
  nombreArchivo: string | null | undefined
): { codigo: string; slot: AlianzaSlot } {
  const raw = String(nombreArchivo ?? '').trim();
  const match = SLOT_RE.exec(raw);
  if (match) {
    const codigo = normalizarCodigoAlianza(match[1]) || match[1].toUpperCase();
    return { codigo, slot: match[2].toUpperCase() as AlianzaSlot };
  }
  const codigo = normalizarCodigoAlianza(raw) || raw.toUpperCase() || 'ALIADO';
  return { codigo, slot: ALIANZA_SLOT.CARD };
}

export function esCabeceraAlianza(nombreArchivo: string | null | undefined): boolean {
  return parseAlianzaNombreArchivo(nombreArchivo).slot === ALIANZA_SLOT.CARD;
}

export function ordenAlianzaSlot(base: number, slot: AlianzaSlot): number {
  return base + ALIANZA_ORDEN_SLOT[slot];
}

export function siguienteBaseOrdenAlianza(ordenes: Array<number | null | undefined>): number {
  const max = Math.max(0, ...ordenes.map((n) => Number(n) || 0));
  return Math.ceil((max + 1) / ALIANZA_GRUPO_ORDEN_SPAN) * ALIANZA_GRUPO_ORDEN_SPAN;
}

export function agruparFilasAlianza(rows: AlianzaFila[]): AlianzaGrupo[] {
  const map = new Map<string, AlianzaGrupo>();
  for (const row of rows) {
    const { codigo, slot } = parseAlianzaNombreArchivo(row.nombreArchivo);
    let grupo = map.get(codigo);
    if (!grupo) {
      grupo = { codigo, filas: [], porSlot: {} };
      map.set(codigo, grupo);
    }
    grupo.filas.push(row);
    grupo.porSlot[slot] = row;
  }
  return [...map.values()].sort((a, b) => {
    const oa = Number(a.porSlot.CARD?.orden ?? a.filas[0]?.orden ?? 0);
    const ob = Number(b.porSlot.CARD?.orden ?? b.filas[0]?.orden ?? 0);
    return oa - ob;
  });
}
